import axios from "axios";
import store from "@/store";

const domain = process.env.VUE_APP_AUTH_REPOSITORY_URL;

export default {
  createRequest() {
    const instance = axios.create({ baseURL: domain });

    instance.interceptors.request.use((config) => {
      const token = localStorage.getItem('auth__access_token');

      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }

      return config;
    });

    instance.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 401 || error.response.status === 400) {
          store.dispatch("AUTH_LOGOUT").then(() => {
            window.location.href = "#/login";
          });
        }
        return Promise.reject(error);
      }
    );

    return instance;
  },
  checkLogin() {
    return this.createRequest().get("/");
  },
  signUp(username, email, password) {
    return this.createRequest().post("sign-up", { username, email, password });
  },
  signUpGuest(username, email, password) {
    return this.createRequest().post("sign-up/guest", {
      username,
      email,
      password,
    });
  },
  resendConfirmation(username) {
    return this.createRequest().post("resend-confirmation", { username });
  },
  confirmSignUp(username, code) {
    return this.createRequest().post("confirm-sign-up", { username, code });
  },
  invite(username, email, password) {
    return this.createRequest().post("invite", { username, email, password });
  },
  login(username, password) {
    let request = this.createRequest();
    return request.post("login", { username, password });
  },
  logout(username) {
    return this.createRequest().post("logout", { username });
  },
  change(username, password, session) {
    return this.createRequest().post("change", { username, password, session });
  },
  refresh(token, bearer_token) {
    return this.createRequest().post("refresh", { token, bearer_token });
  },
  passwordReset(email) {
    return this.createRequest().post("reset-password", { email });
  },
  passwordResetConfirm(email, code, password) {
    return this.createRequest().post("reset-password-confirm", { email, code, password });
  },
};
